import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  WritableSignal,
} from "@angular/core";
import { Router } from "@angular/router";
import { TranslocoDirective } from "@jsverse/transloco";
import {
  AutoCompleteCompleteEvent,
  AutoCompleteModule,
  AutoCompleteSelectEvent,
} from "primeng/autocomplete";
import { Project } from "../../interfaces/project.interface";
import { ProjectManagementService } from "../../services/project-management.service";

@Component({
  selector: "app-project-search",
  imports: [CommonModule, AutoCompleteModule, TranslocoDirective],
  templateUrl: "./project-search.component.html",
  styleUrl: "./project-search.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectSearchComponent {
  protected router = inject(Router);
  protected projectService = inject(ProjectManagementService);

  suggestions: WritableSignal<Project[]> = signal([]);
  private searchQuery = "";

  search(event: AutoCompleteCompleteEvent): void {
    const query = event.query;

    if (!query || query.trim().length < 2) {
      this.suggestions.set([]);
      return;
    }

    this.searchQuery = query;
    this.performSearch(query);
  }

  private performSearch(query: string): void {
    this.projectService
      .getProjects(
        { page: 0, size: 10, sort: "createdAt,DESC" },
        { search: query },
      )
      .subscribe({
        next: (response) => {
          // Only update if this is still the current search query
          if (this.searchQuery === query) {
            this.suggestions.set(response.content);
          }
        },
        error: () => {
          if (this.searchQuery === query) {
            this.suggestions.set([]);
          }
        },
      });
  }

  onSelect(event: AutoCompleteSelectEvent): void {
    const project = event.value;
    if (project?.id) {
      // Fix for the angular problem of not reloading the component on same route routing.
      this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
        this.router.navigate(["/project-management/projects", project.id]);
      });
    }
  }
}
